<div class="flex-column w-100% main-footer">
  <div class="justify-content-center flex-row w-100">
    <div class="main-text-font main-links-color links-div" (click)="openAboutUs()">About Us</div>
    <div class="main-text-font main-links-color links-div" (click)="openDisclaimer()">Disclaimer</div>
    <div class="main-text-font main-links-color links-div" (click)="openTermsOfUse()">Terms of Use</div>
    <div class="main-text-font main-links-color links-div" (click)="openContactUs()">Contact Us</div>
  </div>
  <div class="main-text-font w-100 justify-content-center flex-row align-items-center">
    <span class="text-center">Copyright © 1992-2023 DPC DATA Inc.<br> All rights reserved.</span>
  </div>
</div>
